import { render, staticRenderFns } from "./VideosSlider.vue?vue&type=template&id=39e956b4&scoped=true&"
import script from "./VideosSlider.vue?vue&type=script&lang=js&"
export * from "./VideosSlider.vue?vue&type=script&lang=js&"
import style0 from "./VideosSlider.vue?vue&type=style&index=0&id=39e956b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e956b4",
  null
  
)

export default component.exports